module.exports = __webpack_public_path__ + "static/media/try_the_demo.3bfdd465.svg";